import { Component, OnInit } from '@angular/core';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { Nps } from 'src/app/modules/_models/nps';
import * as alerts from 'src/app/modules/_functions/alerts';
import * as _ from 'lodash';
@Component({
  selector: 'app-nps',
  templateUrl: './nps.component.html',
  styleUrls: ['./nps.component.scss'],
})
export class NpsComponent implements OnInit {
  public exibirLoader: boolean = false;

  public exibirNPSLoja: boolean = false;
  public exibirNPSEcommerce: boolean = false;

  public notas: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  public lojas: any[] = [];

  private compras: Nps[] = [];
  private comprasEcommerce: Nps[] = [];

  constructor(private fidelidade: FidelidadeService) {}

  ngOnInit(): void {
    this.verificarSeHouveCompras();
  }

  private verificarSeHouveCompras() {
    this.fidelidade.verificarSeHouveCompras().subscribe(
      (res) => this.processarSucessoVerificacao(res),
      (err) => this.processarFalahaVerificacao(err)
    );
  }

  private processarSucessoVerificacao(res) {
    const codigoLojaEcommerce = 6045;

    this.compras = _.filter(res, function (compra) {
      return compra.codigoLoja !== codigoLojaEcommerce;
    });
    this.comprasEcommerce = _.filter(res, function (compra) {
      return compra.codigoLoja === codigoLojaEcommerce;
    });

    if (this.compras.length > 0) {
      this.compras.forEach((compra) => {
        const loja = compra.loja.trim();
        if (!this.lojas.includes(loja)) {
          this.lojas.push(loja);
        }
      });
      this.exibirNPSLoja = true;
    }

    this.exibirNPSEcommerce = this.comprasEcommerce.length > 0;
  }

  private processarFalahaVerificacao(err) {
    console.error('Ocorreu um erro ao verificar se houve compras', err);
  }

  public selecionarNotaLoja(nota: number): void {
    this.exibirLoader = true;
    this.compras.forEach((compra) => {
      compra.nota = nota;
    });

    this.fidelidade.enviarNota(this.compras).subscribe(
      (res) => this.processarSucessoEnvioNota(res, 'loja'),
      (err) => this.processarFalhaEnvioNota(err)
    );
  }

  public selecionarNotaEcommerce(nota: number): void {
    this.exibirLoader = true;
    this.comprasEcommerce.forEach((compra) => {
      compra.nota = nota;
    });

    this.fidelidade.enviarNota(this.comprasEcommerce).subscribe(
      (res) => this.processarSucessoEnvioNota(res, 'ecommerce'),
      (err) => this.processarFalhaEnvioNota(err)
    );
  }

  private processarSucessoEnvioNota(res, tipo): void {
    if (tipo === 'loja') {
      this.exibirNPSLoja = false;
    }
    if (tipo === 'ecommerce') {
      this.exibirNPSEcommerce = false;
    }

    this.exibirLoader = false;
    alerts.exibirToast('success', 'Agradecemos sua avaliação.');
  }

  private processarFalhaEnvioNota(err): void {
    this.exibirLoader = false;
    console.error('Ocorreu um erro ao tentar enviar a nota!', err);
  }

  fecharPopupEcommerce() {
    this.exibirNPSEcommerce = false;
  }

  fecharPopupLoja() {
    this.exibirNPSLoja = false;
  }
}
